<template>
  <div class="text--primary">
    <span class="footer-text" :inner-html.prop="getFormatedHtml(selectedInitiative.message)"></span>
  </div>
</template>

<script>
export default {
  props: {
    selectedInitiative: {
      type: Object,
    },
  },
  data() {
    return {
      htmlformated: {},
    };
  },
  methods: {
    getFormatedHtml(text) {
      if (text) {
        let html_ = text.replace(/\*(.*?)\*/g, '<b>$1</b>')
        html_ = html_.replace(/\$(\w+)/g, '<b style="color: purple">$&</b>')
        return html_
      }
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;1,300;1,400&display=swap");
span.footer-text {
  white-space: pre-line;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 10px;
  i{
    font-weight: 10;
  }
}
</style>